"use client";

import { Button } from "@/components/ui/button";
import KenpoImage from "@public/kenpo-image.png";
import Image from "next/image";
import { type ReactElement } from "react";

type ErrorCode = "401" | "403" | "404" | "500";

const errorTitle = {
  "401": "Unauthorized",
  "403": "Forbidden",
  "404": "Page Not Found",
  "500": "Internal Server Error",
} satisfies Record<ErrorCode, string>;

const errorMessage = {
  "401": "このページにアクセスする権限がありません。",
  "403": "このページにアクセスする権限がありません。",
  "404": "アクセスしようとしたページは見つかりませんでした。",
  "500": "アクセスしようとしたページは表示できませんでした。",
} satisfies Record<ErrorCode, string>;

export const ErrorPage = ({
  errorCode,
  actionButtonElement,
}: {
  errorCode: ErrorCode;
  actionButtonElement?: ReactElement;
}) => {
  return (
    <div className="flex max-h-screen min-h-screen flex-col items-center justify-between p-5">
      <div className="flex flex-col gap-10">
        <h1 className="mt-5 text-2xl font-bold whitespace-pre-wrap text-primary-6">
          {errorCode}
          {"\n"}
          {errorTitle[errorCode]}
        </h1>
        <p>{errorMessage[errorCode]}</p>
        {actionButtonElement}
      </div>
      <div className="md:p-5 lg:max-w-[75%] xl:max-w-[50%]">
        <Image src={KenpoImage} alt="" className="object-contain" />
      </div>
    </div>
  );
};

const GlobalError = ({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  return (
    <html>
      <body>
        <ErrorPage
          errorCode="500"
          actionButtonElement={
            <Button variant="primary" onClick={() => reset()}>
              再読み込み
            </Button>
          }
        />
      </body>
    </html>
  );
};

export default GlobalError;
